import "../assets/scss/main.scss";

import lenis from "./modules/lenis";
import { initParallax } from "./modules/parallax";
import { initReveal } from "./modules/reveal";
import { initScrollX } from "./modules/scroll-x";
import { initRobotsShowcase } from "./modules/robots-showcase";
import { initAnimateIn } from "./modules/animate";
import { initNewsletter, initNewsletterPopup } from "./modules/newsletter";
import { initGlightbox } from "./modules/glightbox";
import { initCta } from "./modules/cta";
import { initServices } from "./modules/services";
import { initMobileMenu } from "./modules/mobile-menu";
import { initHeaderScroll } from "./modules/header";
import { initWorkArchive } from "./modules/work-archive";
import { initAnchorScroll } from "./modules/anchor-scroll";

initReveal();
initParallax();
initScrollX();
initRobotsShowcase();
initAnimateIn();
initNewsletter();
initNewsletterPopup();
initGlightbox();
initCta();
initServices();
initMobileMenu();
initHeaderScroll();
initWorkArchive();
initAnchorScroll();
